import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {ProjectReference} from '../models/project-reference';
import {TeamMember} from '../models/team-member';
import {ProjectReferenceDetailResponse} from '../models/project-reference-detail.response';
import {LinkType} from '../models/link';

export interface TeamMemberService {
    create(refId: number, teamMember: TeamMember): Observable<TeamMember>;
    update(refId: number, teamMember: TeamMember): Observable<TeamMember>;
    delete(refId: number, teamMember: TeamMember): Observable<void>;
    list(refId: number): Observable<TeamMember[]>;
}

@Injectable()
export class TeamMemberServiceImpl implements TeamMemberService {
    protected http = inject(HttpClient);


    create(refId: number, teamMember: TeamMember): Observable<TeamMember> {
        return this.http.post<TeamMember>(`/api/v1/project-references/${refId}/team-members`, {
            name: teamMember.name,
            role: teamMember.role
        });
    }

    delete(refId: number, teamMember: TeamMember): Observable<void> {
        return this.http.delete<void>(`api/v1/project-references/${refId}/team-members/${teamMember.id}`);
    }

    update(refId: number, teamMember: TeamMember): Observable<TeamMember> {
        return this.http.put<TeamMember>(`/api/v1/project-references/${refId}/team-members/${teamMember.id}`, {
            name: teamMember.name,
            role: teamMember.role
        });
    }

    list(refId: number): Observable<TeamMember[]> {
        return this.http.get<TeamMember[]>(`/api/v1/project-references/${refId}/team-members`);
    }
}
